//import AOS from 'aos';
//import 'aos/dist/aos.css';

export function setCookie(name, value, days) {
    var now = new Date();
    var expTime = now.getTime() + days * 24 * 60 * 60 * 1000;
    var expDate = new Date(expTime);
    document.cookie = name + "=" + value + "; EXPIRES=" + expDate.toGMTString() + "; path=/";
}
export function getCookie(name) {

    var start = document.cookie.indexOf(name + "=");
    if (start == -1)
        return null;
    var len = start + name.length + 1;
    var end = document.cookie.indexOf(";", len);
    if (end == -1)
        end = document.cookie.length;
    return document.cookie.substring(len, end)
}

export function initializeMap(map0) {

    var mapData = JSON.parse(map0.dataset.map.replace(/'/g, '"'));

    var mapOptions = {
        center: new google.maps.LatLng(mapData[0]['map-lat'], mapData[0]['map-lng']),
        zoom: 14,
        panControl: false,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: true,
        overviewMapControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        styles: [
            {
                stylers: [
                    { saturation: -100 }
                ]
            }
        ]
    };
    var image = "../wp-content/themes/localone/images/marker.png";
    var map = new google.maps.Map(map0, mapOptions);
    map.myOrigins = map.getCenter();
    var bounds = new google.maps.LatLngBounds();

    mapData.forEach(function (elem) {
        elem.marker = new google.maps.Marker({
            position: new google.maps.LatLng(elem['map-lat'], elem['map-lng']),
            map: map,
            icon: image
        });
        bounds.extend(elem.marker.position);
        google.maps.event.addListener(elem.marker, 'click', function () {
            window.open(elem['map-link']);
        });
    });
    if (mapData.length > 1) {
        map.fitBounds(bounds);
    }

}


/**
* init menu trigger (onClisk)
 */
export const initMenuTrigger = () => {
    const menuTrigger = document.querySelector('.menuTrigger');
    if (menuTrigger) {
        document.querySelectorAll('.menuTrigger').forEach((item) => item.addEventListener('click', e => {
            document.body.classList.toggle('showMenu');
        }));
    }
}

/**
    * init open link in new tab on click for class "newWindow"
    */
export const initOpenInNewTab = () => {
    const newWindow = document.querySelectorAll('.newWindow');
    if (newWindow && newWindow.length > 0) {
        newWindow.forEach(item =>
            item.addEventListener('click', e => {
                e.preventDefault();

                window.open(item.href);
                return false;
            })
        );
    }
}
/**
 * add AOS animation config
 */
/*
export const aosConfig = () => {
    if (typeof AOS !== 'undefined') {
        const anims = document.querySelectorAll('.animUp');
        if (anims.length > 0) {
            [...anims].forEach((anim) => anim.dataset.aos = 'myUp');
        }
        AOS.init({
            duration: 1200,
            // offset: wh * 0.25,
            offset: 100,

            once: true,
            easing: 'ease-out-back',
        });
    }
}
*/

/**
 * add/remove hideScrolledMenu class to body based on scroll direction and position
 */
export const addHideScrolledMenuClass = () => {
    const scrollFactor = 0.4; // Procent wysokości ekranu
    let lastScrollY = window.scrollY;
    let halfScreenHeight = window.innerHeight * scrollFactor;


    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > 0) {
            document.body.classList.add('scroll');
        } else {
            document.body.classList.remove('scroll');
        }

        // Sprawdzamy czy przekroczyliśmy połowę wysokości ekranu
        if (currentScrollY > halfScreenHeight) {
            // Sprawdzamy kierunek scrollowania
            if (currentScrollY > lastScrollY) {
                // Scrollujemy w dół - dodajemy klasę
                document.body.classList.add('hideScrolledMenu');
            } else {
                // Scrollujemy w górę - usuwamy klasę
                document.body.classList.remove('hideScrolledMenu');
            }
        } else {
            // Jeśli jesteśmy powyżej połowy ekranu, zawsze usuwamy klasę
            document.body.classList.remove('hideScrolledMenu');
        }

        lastScrollY = currentScrollY;
    };

    // Dodajemy event listener z throttling dla lepszej wydajności
    let ticking = false;
    const throttledScroll = () => {
        if (!ticking) {
            requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener('scroll', throttledScroll, { passive: true });
    throttledScroll(); // Wywołujemy od razu, aby ustawić klasę na podstawie początkowej pozycji scrolla

    // Aktualizujemy halfScreenHeight przy zmianie rozmiaru okna
    window.addEventListener('resize', () => {
        halfScreenHeight = window.innerHeight * scrollFactor;
    }, { passive: true });
}



/**
 * add class 'gallery-item', fix for fancybox plugin
 * @param {string} cn 
 */
export const galleryAddItemClass = (cn) => {
    const galleryItemFancybox = document.querySelectorAll(cn);
    if (galleryItemFancybox && galleryItemFancybox.length > 0) {
        galleryItemFancybox.forEach(item => {
            item.classList.add('gallery-item');
        });
    }
}

/**
 * add id to gallery holder, fix for fancybox plugin
 * @param {string} gallery 
 */
export const addFancyboxFixForGallery = (gallery) => {
    const galleryFancybox = document.querySelectorAll(gallery);
    if (galleryFancybox && galleryFancybox.length > 0) {
        galleryFancybox.forEach(gallery => {
            const galleryAnchors = gallery.querySelectorAll(':scope a');
            const galeeryId = 'gal' + (Math.floor(Math.random() * 100));
            if (galleryAnchors && galleryAnchors.length > 0) {
                galleryAnchors.forEach(galeeryAnchor => {
                    galeeryAnchor.dataset.fancybox = galeeryId;
                    galeeryAnchor.dataset.caption = galeeryAnchor.nextSibling ? galeeryAnchor.nextSibling.innerHTML : '';
                });
            }
        });
    }
}

/**
 * add close on click for cookies box
 */
const hideCookies = () => {
    document.querySelector('.cookies').classList.add('hide');
}
export const addCloseCookies = () => {
    const cookieBtn = document.querySelector('.cookies__close');
    if (cookieBtn) {
        cookieBtn.addEventListener('click', e => {
            setCookie('hideCookieAlert', 1, 360);
            hideCookies();
            return false;
        });
    }
    if (getCookie('hideCookieAlert')) {
        hideCookies();
    }
}



/**
 * init form script fix
 */
export const initForm = () => {

    var wpcf7Elm = document.querySelectorAll('.wpcf7');
    const inputs = document.querySelectorAll('.wpcf7 input[type=text],.wpcf7 input[type=email],.wpcf7 input[type=tel],.wpcf7 textarea,.wpcf7 select');
    if (inputs) {
        inputs.forEach(item => {
            //item.value = '';
            if (item.nodeName == 'SELECT') item.value = '';
            item.addEventListener('focus', e => e.target.parentNode.parentNode.querySelector(':scope label').classList.add('show'));
            item.addEventListener('focusout', e => {
                if (e.target.value == '' || e.target.value == null) {
                    e.target.parentNode.parentNode.querySelector(':scope label').classList.remove('show')
                }
            });
        });
    }
    const inputsFiles = document.querySelectorAll('.wpcf7 input[type="submit"]');
    if (inputsFiles) {
        inputsFiles.forEach(button => {
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.attributeName === 'disabled' && button.disabled) {
                        button.removeAttribute('disabled');
                    }
                });
            });
            observer.observe(button, { attributes: true });
            button.removeAttribute('disabled');
        });
    }

    if (wpcf7Elm) {
        wpcf7Elm.forEach(wpcf7ElmItem => {
            wpcf7ElmItem.addEventListener('wpcf7invalid', function (event) {
                document.querySelectorAll('.wpcf7-not-valid')
                    .forEach((item) => {
                        if (item.value != "") {
                            item.parentNode.parentNode.querySelector(':scope label').classList.add('show')
                        }
                    });
                jQuery('html,body').animate({ 'scrollTop': ($(wpcf7ElmItem).offset().top - 100) + 'px' }, 500);
            }, false);
            wpcf7ElmItem.addEventListener('wpcf7mailsent', function (event) {
                document.querySelectorAll('.wpcf7 input').forEach((item) => {
                    if (item.parentNode.parentNode.querySelector(':scope label'))
                        item.parentNode.parentNode.querySelector(':scope label').classList.remove('show');
                });
                jQuery('html,body').animate({ 'scrollTop': ($(wpcf7ElmItem).offset().top - 100) + 'px' }, 500);
            }, false);
        });

    }
}



/**
 * google map (API) init
 */
export const googleMapInit = () => {
    var map = document.querySelector('.contactMap');
    if (map && typeof google !== 'undefined') {
        google.maps.event.addDomListener(window, 'load', function () {
            initializeMap(map);
        });

    }
}



export const initLoadNews = () => {
    if (!!window.IntersectionObserver) {
        let newsCanBeLoaded = true;
        const newsAjaxTrigger = document.querySelector('.newsAjaxTrigger');
        let addNewsObserver = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                if (newsCanBeLoaded) {
                    loadNews();
                }
            }
        });

        if (newsAjaxTrigger) {
            addNewsObserver.observe(newsAjaxTrigger);
        }

        const loadNews = () => {
            const newsAjaxTrigger = document.querySelector('.newsAjaxTrigger');
            if (newsAjaxTrigger) {
                newsCanBeLoaded = false;
                newsAjaxTrigger.classList.add('show');
                const formData = new FormData();
                formData.append('action', 'loadmore');
                formData.append('query', ajaxParams.posts);
                formData.append('page', ajaxParams.current_page);
                fetch(ajaxParams.ajaxurl, {
                    method: "post",
                    body: formData
                })
                    .then(res => res.text())
                    .then(res => {
                        if (res) {
                            newsCanBeLoaded = true;
                            ajaxParams.current_page++;
                            newsAjaxTrigger.classList.remove('show');
                            document.querySelector('.newsList').insertAdjacentHTML('beforeend', res);
                        } else {
                            newsCanBeLoaded = false;
                            document.querySelector('.newsAjaxTrigger').remove();
                            addNewsObserver.disconnect();
                        }

                    });
            }

        }
    }
}

const faqServiceTrigger = (trigger, faqHolder) => {
    const tParent = trigger.parentNode;
    const tContent = tParent.querySelector(':scope .gFaq__content');

    [...faqHolder.querySelectorAll(':scope .gFaq__item.active')].forEach((item) => {
        if (!item.isSameNode(tParent)) {
            item.classList.remove('active');
            jQuery(item.querySelector(':scope .gFaq__content')).stop(true, true).slideUp(500)
        }
    });

    if (!tParent.classList.contains('active')) {
        typeof jQuery == "function" ? jQuery(tContent).stop(true, true).slideDown(500) : null;
    } else {
        typeof jQuery == "function" ? jQuery(tContent).stop(true, true).slideUp(500) : null;
    }
    tParent.classList.toggle('active');

}

export const faqService = () => {
    const faq = document.querySelectorAll('.gFaq');

    if (faq.length > 0) {
        [...faq].forEach((faqItem) => {
            const triggers = faqItem.querySelectorAll(':scope .gFaq__trigger');
            if (triggers.length > 0) {
                [...triggers].forEach((trigger) => {
                    trigger.addEventListener('click', () => faqServiceTrigger(trigger, faqItem));
                });
            }

        });
    }

}

export function onClassChange(node, className, callback) {


    const mutationObserver = new MutationObserver((mutationList) => {
        for (const item of mutationList) {
            if (item.attributeName === "class") {
                if (node.classList.contains(className)) {
                    callback(mutationObserver);
                    break;
                }
            }
        }
    });

    mutationObserver.observe(node, { attributes: true });

    return mutationObserver;
}

export const initGallerySlider = () => {
    let galleries = document.querySelectorAll('.wp-block-gallery.is-style-gallerySlider');
    if (galleries.length > 0) {
        [...galleries].forEach((gallery) => {
            let galHolder = document.createElement('div');
            let caption = gallery.querySelector(':scope .blocks-gallery-caption');
            galHolder.classList.add('gGallerySliderHolder');
            gallery.parentNode.insertBefore(galHolder, gallery);
            galHolder.appendChild(gallery);
            if (caption) {
                galHolder.appendChild(caption);
            }
            gallery.classList.add('slickSliderUi');
            gallery.classList.add('gGallerySlider');
            typeof jQuery == "function" ? $(gallery).slick({
                infinite: false,
                arrows: true,
                dots: true,
                autoplay: false,
                speed: 500,
                autoplaySpeed: 3000,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            }) : null;
        });
    }
}

export const initLazyBg = (className = 'lazyBg') => {
    let lazyBgList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.remove(className);
                    lazyImageObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '150px 0px'
        });
        lazyBgList.forEach(function (lazyBg) {
            lazyImageObserver.observe(lazyBg);
        });
    }

}

export const initLazyVideo = (className = 'lazyVideo') => {
    const videos = [].slice.call(document.querySelectorAll('video.' + className));
    if (!videos.length || !("IntersectionObserver" in window)) return;

    const loadObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            const video = entry.target;
            video.querySelectorAll('source[data-src]').forEach(function (source) {
                source.src = source.dataset.src;
                source.removeAttribute('data-src');
            });
            if (video.dataset.src) {
                video.src = video.dataset.src;
                video.removeAttribute('data-src');
            }
            video.load();
            observer.unobserve(video);
        });
    }, {
        rootMargin: '150px 0px'
    });

    const playObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            const video = entry.target;
            const p = video.play();
            if (p !== undefined) p.catch(function () { });
            observer.unobserve(video);
        });
    }, {
        threshold: 0.01
    });

    videos.forEach(function (video) {
        loadObserver.observe(video);
        playObserver.observe(video);
    });
};

export const initMediaTextVideo = (selector = '.wp-block-media-text') => {
    const videos = [].slice.call(document.querySelectorAll(selector + ' video'));
    if (!videos.length || !("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            const video = entry.target;
            const p = video.play();
            if (p !== undefined) p.catch(function () { });
            observer.unobserve(video);
        });
    }, {
        rootMargin: '-50% 0px -50% 0px'
    });

    videos.forEach(function (video) {
        observer.observe(video);
    });
};

export const animUp = (className = 'animUp') => {
    let lazyBgList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.remove(className);
                    lazyImageObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '150px 0px'
        });
        lazyBgList.forEach(function (lazyBg) {
            lazyImageObserver.observe(lazyBg);
        });
    }


}

export const initShow = (className = 'animUp', classNameAdd = 'show') => {
    let showList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add(classNameAdd);
                    lazyImageObserver.unobserve(entry.target);
                } /*else {
                    entry.target.classList.remove(classNameAdd);
                }*/
            });
        }, {
            rootMargin: '0px 0px -15% 0px'
        });
        showList.forEach(function (show) {
            lazyImageObserver.observe(show);
        });
    }

}
export const onElementShow = (node, once = false, callback) => {


    if ("IntersectionObserver" in window) {
        let elementShowObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    if (typeof callback === 'function')
                        callback();
                    if (once)
                        elementShowObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '0px 0px -15% 0px'
        });

        elementShowObserver.observe(node);

    }

}


export const initCounting = () => {
    const items = document.querySelectorAll('span.counting');
    if (!items.length) return;

    items.forEach(el => {
        const original = el.textContent.trim();
        const num = parseFloat(original.replace(/\s/g, '').replace(',', '.'));
        if (isNaN(num)) return;

        // Determine decimal places from original format (using comma or dot)
        const match = original.replace(/\s/g, '').match(/[.,](\d+)$/);
        const decimals = match ? match[1].length : 0;

        // Check if original uses space as thousands separator
        const usesSpaces = /\d\s\d/.test(original);
        // Check if original uses comma as decimal separator
        const usesComma = /,\d+$/.test(original.replace(/\s/g, ''));

        // Store prefix/suffix (e.g. "+" at end, currency symbols, etc.)
        const prefixMatch = original.match(/^([^\d]*)/);
        const suffixMatch = original.match(/([^\d\s.,]*)$/);
        const prefix = prefixMatch ? prefixMatch[1] : '';
        const suffix = suffixMatch ? suffixMatch[1] : '';

        el.setAttribute('data-counting', num);
        el.setAttribute('data-counting-decimals', decimals);
        el.setAttribute('data-counting-spaces', usesSpaces ? '1' : '0');
        el.setAttribute('data-counting-comma', usesComma ? '1' : '0');
        el.setAttribute('data-counting-prefix', prefix);
        el.setAttribute('data-counting-suffix', suffix);
        el.textContent = prefix + '0' + suffix;
    });

    const formatNumber = (value, decimals, usesSpaces, usesComma) => {
        let str = value.toFixed(decimals);
        if (usesComma && decimals > 0) {
            str = str.replace('.', ',');
        }
        if (usesSpaces) {
            const parts = str.split(/[.,]/);
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            if (parts[1] !== undefined) {
                str = parts[0] + (usesComma ? ',' : '.') + parts[1];
            } else {
                str = parts[0];
            }
        }
        return str;
    };

    const duration = 2000;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            observer.unobserve(el);

            const target = parseFloat(el.getAttribute('data-counting'));
            const decimals = parseInt(el.getAttribute('data-counting-decimals'));
            const usesSpaces = el.getAttribute('data-counting-spaces') === '1';
            const usesComma = el.getAttribute('data-counting-comma') === '1';
            const prefix = el.getAttribute('data-counting-prefix');
            const suffix = el.getAttribute('data-counting-suffix');

            let start = null;
            const step = (timestamp) => {
                if (!start) start = timestamp;
                const progress = Math.min((timestamp - start) / duration, 1);
                // easeOutQuart for smooth deceleration
                const eased = 1 - Math.pow(1 - progress, 4);
                const current = eased * target;

                el.textContent = prefix + formatNumber(current, decimals, usesSpaces, usesComma) + suffix;

                if (progress < 1) {
                    requestAnimationFrame(step);
                }
            };
            requestAnimationFrame(step);
        });
    }, {
        rootMargin: '0px 0px -15% 0px'
    });

    items.forEach(el => {
        if (el.hasAttribute('data-counting')) {
            observer.observe(el);
        }
    });
};

/**
 * Detects when each .stickyCard is pinned at the top and toggles the .small
 * class on it (CSS handles the transform). No DOM injection, no scroll listeners.
 *
 * Trick: rootMargin shrinks the root to a 1px horizontal strip at the sticky
 * line. A card "intersects" this strip iff its top <= stickyOffset AND its
 * bottom >= stickyOffset - i.e. it is currently pinned.
 */
export const initStickyCardStack = (selector = '.stickyCard', stickyOffset = 20) => {
    const cards = Array.from(document.querySelectorAll(selector));
    if (cards.length < 2 || !('IntersectionObserver' in window)) return;

    let observer;
    const setupObserver = () => {
        if (observer) observer.disconnect();
        const bottomMargin = Math.max(0, window.innerHeight - stickyOffset - 1);
        observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                entry.target.classList.toggle('small', entry.isIntersecting);
            });
        }, {
            rootMargin: `-${stickyOffset}px 0px -${bottomMargin}px 0px`,
            threshold: 0
        });
        cards.forEach((card) => observer.observe(card));
    };

    setupObserver();

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(setupObserver, 200);
    });
};